// src/config/firebase.js
//
// PRD-022 INC-2 — inicialização do Firebase JS SDK (FCM-for-Web, DT-1).
//
// A config do Web app é PÚBLICA (vai pro browser de qualquer jeito) e vem das
// envs VUE_APP_FIREBASE_* (Vue CLI / Webpack — nunca import.meta.env). A chave
// VAPID pública também. Os valores ficam no .env.local (gitignored); ver
// .env.example. O service worker de background (firebase-messaging-sw.js) tem a
// mesma config inlined (um SW não lê process.env em runtime).
//
// Tudo é defensivo: sem config, isFirebaseConfigured() = false e o app não
// quebra — a UI de push apenas mostra "não configurado".

import { initializeApp, getApps, getApp } from "firebase/app";
import { getMessaging, isSupported } from "firebase/messaging";
import { logger } from "@/utils/logger";

const firebaseConfig = {
  apiKey: process.env.VUE_APP_FIREBASE_API_KEY,
  authDomain: process.env.VUE_APP_FIREBASE_AUTH_DOMAIN,
  projectId: process.env.VUE_APP_FIREBASE_PROJECT_ID,
  messagingSenderId: process.env.VUE_APP_FIREBASE_MESSAGING_SENDER_ID,
  appId: process.env.VUE_APP_FIREBASE_APP_ID,
};

/**
 * Chave VAPID pública (Cloud Messaging → Web Push certificates). OPCIONAL: se
 * vazia, o getToken usa a DEFAULT_VAPID_KEY embutida do Firebase SDK (mesmo
 * comportamento do ptm-web, que chama getToken() sem VAPID). Só preencha para
 * usar um Web Push certificate próprio.
 */
export const VAPID_KEY = process.env.VUE_APP_FIREBASE_VAPID_KEY || "";

/**
 * Há config mínima suficiente para inicializar o FCM-for-Web? A VAPID NÃO é
 * exigida (default do SDK cobre) — só os 5 valores públicos do Web app.
 */
export function isFirebaseConfigured() {
  return Boolean(
    firebaseConfig.apiKey &&
      firebaseConfig.projectId &&
      firebaseConfig.messagingSenderId &&
      firebaseConfig.appId,
  );
}

let _app = null;
function getFirebaseApp() {
  if (!isFirebaseConfigured()) return null;
  if (_app) return _app;
  _app = getApps().length ? getApp() : initializeApp(firebaseConfig);
  return _app;
}

let _messaging = null;
/**
 * Instância de messaging, ou null quando: sem config, navegador sem suporte
 * (Notification/SW/push) ou erro de init. Nunca lança.
 */
export async function getMessagingInstance() {
  if (!isFirebaseConfigured()) return null;
  try {
    if (!(await isSupported())) return null;
    if (_messaging) return _messaging;
    const app = getFirebaseApp();
    if (!app) return null;
    _messaging = getMessaging(app);
    return _messaging;
  } catch (err) {
    logger.error("[push] Firebase messaging não suportado neste ambiente:", err);
    return null;
  }
}

export { firebaseConfig };
